import chameleon from "@chamaeleonidae/chmln";
import { IVendorUser } from "@smartrr/shared/entities/VendorUser";
import config from "@vendor-app/config";

export function initChameleon(authUser: IVendorUser): void {
  const { isSuperUser, chameleonHash } = authUser;

  if (isSuperUser) {
    console.warn("skipped Chameleon initialization if current user is a super user");

    return;
  }

  if (typeof (window as any).chmln !== "undefined") {
    return;
  }

  chameleon.init(config.chameleon.clientToken, { fastUrl: "https://fast.chameleon.io/" });

  chameleon.identify(authUser.id, {
    uid_hash: chameleonHash,
    email: authUser.originalEmail,
    App: "Smartrr",
  });
}
